// Previous payment URLs kept for reference:
// https://z5-ppw.phreesia.net/z5/patient/Payment.aspx/Start?encrypted=PmUx0k5lthSgT5jGeQm3NwLtvIyX9hCBBBQn9XLJnVpykMrEPg9N8Et5jticCc9hOMd8C8EQTzR41hgP1wIFFbQMSyBTRB2RCIst45wOU_21EZi0rAFGUrCIINKTFEcp3IBiP8yTrOyzw-hFnEJphUnNzGWlBlArm67sz1kC5fw1
// https://z1-ppw.phreesia.net/25/patient/Payment.aspx/Start?encrypted=y8Aw23QjQ14_3xpZl8YSL7t2GbZn0H44WU4P6CHBASg3aZzkdSVWqtaz5h66zRG0JFijBCh4-xgd2noMLSe8uV4M9Nt3-Nw8OJjQ33P_i2TEepQI4XWk59Wu08NwaGSPCkdi2Fcl-2vSfSTKXSZrF_QoYeexAMTMrFKXCrt-Yho1

document.querySelectorAll('.o-payment-hero__form').forEach(form => {
  form.addEventListener('submit', event => {
    event.preventDefault();

    const selectedLink = form.querySelector('input[name="payment-link"]:checked');

    if (selectedLink) {
      window.open(selectedLink.value, '_blank', 'noopener');
    }
  });
});
